import * as React from 'react';
import { FieldArray } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import JobContact from 'af-components/SharedForms/Contacts/ContactWrapper';

import AdditionalBillingInformation from './AdditionalBillingInformation';
import AdditionalContacts from './AdditionalContacts';
import WorkRequestUpsertFM from '../../../formModel';
import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../../helpers';
import styles from '../../../styles.module.scss';

type Props = {
	formName: string;
};

const ContactsSection: React.FC<Props> = ({ formName }) => {

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Contacts"
				tooltip="A directory of all relevant contacts associated with this job, including customer, site, and billing contact information."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					Customer Contact
					<JobContact
						className={styles['work-request-form__contact']}
						contactLabel="Enter Customer Contact"
						fieldName={WorkRequestUpsertFM.getAttributeName('customerContact')}
						formName={formName}
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					Site Contact
					<JobContact
						className={styles['work-request-form__contact']}
						contactLabel="Enter Site Contact"
						fieldName={WorkRequestUpsertFM.getAttributeName('siteContact')}
						formName={formName}
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					Billing Contact
					<JobContact
						className={styles['work-request-form__contact']}
						contactLabel="Enter Billing Contact"
						fieldName={WorkRequestUpsertFM.getAttributeName('billingContact')}
						formName={formName}
					/>
				</div>
			</div>
			<AdditionalBillingInformation />
			<FieldArray<void>
				component={AdditionalContacts}
				name={WorkRequestUpsertFM.getAttributeName('additionalContacts')}
			/>
		</div>
	);
};

export default React.memo(ContactsSection);
